import { LobbyImage } from '@colonist/types';
import { createDivIn, createHeaderIn, createImgIn, createParagraphIn, setElementInnerText, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIPopupManager } from '../../ui_popup/UIPopupManager.ts';
import { ColonistMembershipProduct } from '../../../../../shared/store/ColonistMembershipProduct.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../analytics/Analytics.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { UIStoreMembershipProductView } from '../UIStoreMembershipProductView.ts';
import { UIStoreMembershipTabsController } from '../UIStoreMembershipTabsController.ts';
import { applyOwnedMembershipToViews } from '../applyOwnedMembershipToViews.ts';
import { UISubscriptionOverlayState } from './UISubscriptionOverlayState.ts';
import '../../../css/theme/_subscription_overlay.scss';
export class UISubscriptionOverlayController {
    createHeaderSection() {
        const headerContainer = createDivIn(this.mainContainer, 'subscription-overlay-header-container');
        createHeaderIn(headerContainer, {
            key: 'strings:storePage.sections.membership.title'
        }, '', '', 'H2');
        const closeButton = createImgIn(headerContainer, LobbyImage.XMark, 'subscription-overlay-close-button');
        setElementOnClick(closeButton, ()=>this.hide());
    }
    createBodySection() {
        const bodyContainer = createDivIn(this.mainContainer, 'subscription-overlay-body-container');
        this.bodyContainer = bodyContainer;
        const toggleContainer = createDivIn(bodyContainer, 'toggle-container');
        const monthlyTab = createDivIn(toggleContainer, 'toggle-tab');
        setElementInnerText(monthlyTab, {
            key: 'strings:storePage.membership.frequency.monthly',
            options: {
                context: 'store'
            }
        });
        const annualTab = createDivIn(toggleContainer, 'toggle-tab');
        this.membershipsDiv = createDivIn(bodyContainer, 'store_page_items_grid');
        createParagraphIn(bodyContainer, {
            key: 'strings:storePage.sections.membership.tip'
        }, 'subscription-overlay-membership-tip');
        this.overlayState.tabsController = this.createMembershipTabsController(monthlyTab, annualTab);
        this.updateMembershipViews(ClientUserState.userState);
        ClientUserState.registerChangeListener((userState)=>{
            this.finishPurchaseIfMembershipArrived(userState);
            this.updateMembershipViews(userState);
        });
    }
    finishPurchaseIfMembershipArrived(userState) {
        if (this.isOverlayHidden()) return;
        if (this.hadMembershipOnShow) return;
        if (userState === null || userState === void 0 ? void 0 : userState.items.hasMembership()) this.finishSuccessfulPurchase(userState.items.membership);
    }
    finishSuccessfulPurchase(purchasedMembershipType) {
        if (this.isOverlayHidden()) return;
        this.hide();
        const purchaseSuccessEventData = {
            type: AnalyticEventType.SubscriptionOverlayPurchaseSuccess,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: purchasedMembershipType != undefined ? UIStoreMembershipProductView.getMembershipAnalyticValue(purchasedMembershipType) : undefined
        };
        void CA.sendAnalyticEvent(purchaseSuccessEventData);
    }
    isOverlayHidden() {
        return this.mainContainer.classList.contains('hidden');
    }
    updateMembershipViews(userState) {
        this.membershipsDiv.replaceChildren();
        this.overlayState.membershipViews.length = 0;
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts();
        for (const membershipProduct of membershipProducts){
            this.overlayState.membershipViews.push(this.createMembershipProductView(membershipProduct));
        }
        const ownedMembershipType = userState === null || userState === void 0 ? void 0 : userState.items.membership;
        const ownedMembership = ownedMembershipType != undefined ? ColonistMembershipProduct.getMembershipProduct(ownedMembershipType) : undefined;
        applyOwnedMembershipToViews(this.overlayState.membershipViews, ownedMembership, userState === null || userState === void 0 ? void 0 : userState.items.membershipPaymentMethod);
        const toggleYearlyActive = ownedMembership == undefined ? true : ColonistMembershipProduct.isAnnualMembership(ownedMembership.type);
        this.overlayState.membershipToggleYearlyActive = toggleYearlyActive;
    }
    createMembershipProductView(membershipProduct) {
        return new UIStoreMembershipProductView(this.membershipsDiv, this.overlayState, membershipProduct);
    }
    createMembershipTabsController(monthlyTab, annualTab) {
        return new UIStoreMembershipTabsController(this.overlayState, monthlyTab, annualTab);
    }
    show() {
        var _ClientUserState_userState;
        UIPopupManager.closeAllPopups();
        this.hadMembershipOnShow = !!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership());
        this.mainContainer.classList.remove('hidden');
        const overlayShownEventData = {
            type: AnalyticEventType.SubscriptionOverlayShown,
            category: AnalyticEventCategory.ABTestClickAnalytics
        };
        void CA.sendAnalyticEvent(overlayShownEventData);
    }
    hide() {
        this.mainContainer.classList.add('hidden');
    }
    constructor(){
        this.overlayState = new UISubscriptionOverlayState();
        this.hadMembershipOnShow = false;
        this.mainContainer = createDivIn(document.body, 'subscription-overlay-container');
        this.createHeaderSection();
        this.createBodySection();
        this.hide();
        window.addEventListener('focus', ()=>{
            if (!this.isOverlayHidden()) void ClientUserState.refresh();
        });
    }
}
